export default __webpack_public_path__ + "static/media/apple.dcf890bf.jpg";